import React, { useState } from 'react'
import { RiDeleteBin6Fill } from "react-icons/ri";
import { useContext } from 'react';
import { CartContext } from '../../Context/CartProvider';
import { IoReload } from "react-icons/io5";

const CartItem = ({item}) => {
  const [currentQuantity,setCurrentQuantity]=useState(item.quantity);
  const {removeFromCart} = useContext(CartContext);
  const {changeCart} = useContext(CartContext);
  const handelChange = (e) => {
    const quantity=currentQuantity;
    changeCart(item,quantity);
  }
  return (
    <div className='cart-item-container'>
        <div className='cart-item-name'>
        <img src={`/uploads/${item.image}`} alt={item.item} />
            <h3>{item.item}</h3>
            {item.color && <h4>Szín: {item.color}</h4>}
        </div>
        <div className='cart-item-price'>
            <button onClick={handelChange}><IoReload /></button>
            <input type="number"  value={currentQuantity} min={1} max={20} onChange={(e) => setCurrentQuantity(e.target.value)}/>
            <h3>{item.price} Ft</h3>
            <RiDeleteBin6Fill
              onClick={() => removeFromCart(item)}
              style={{ cursor: "pointer" }}
            />
        </div>
    </div>
  )
}

export default CartItem